module.exports = __webpack_public_path__ + "img/Pattern01.cc73ec6b.png";